import { LoginForm } from '@/entities/user/components/LoginForm';
import { Fulfilment } from '@/pages/home/Fulfilment';
import { HomeFooter } from '@/pages/home/HomeFooter';
import { IntegratedTechnologies } from '@/pages/home/IntegratedTechnologies';
import TrustedByIndustryLeadersBlock from '@/pages/home/TrustedByIndustryLeadersBlock';

/**
 * Public landing = login screen (rendered by AccessProvider when `/users/me`
 * is 401). Composition mirrors the legacy monolith's `app/page.tsx` exactly:
 * login hero, Fulfilment marketing block, Integrated Technologies, the
 * Trusted-by-Industry-Leaders logo marquee and the footer. The page is
 * white-on-light like the legacy forced-light theme (the app `--background`
 * gray must not bleed through between blocks).
 */
export function HomePage() {
  return (
    <main
      className="min-h-screen bg-white text-[#0A1524]"
      style={{ fontFamily: "'Inter Variable', Inter, system-ui, sans-serif" }}
    >
      <LoginForm />
      <Fulfilment />
      <IntegratedTechnologies />
      <TrustedByIndustryLeadersBlock />
      <HomeFooter />
    </main>
  );
}
